const initialState = {
  data: {
    list: [],
    total: 0,
  },
  isLoading: true,
  error: "",
};

export const getUsersListSuccess = (state, {payload}) => ({
  ...state,
  data: payload.data,
  isLoading: false,
});

export const resendInviteSuccess = (state, {payload}) => ({
  ...state,
  data: payload,
  isLoading: false,
});

export const cancelInviteSuccess = (state, {payload}) => ({
  ...state,
  data: payload,
  isLoading: false,
});

export const clearList = () => ({...initialState});

export default initialState;
